<template>
  <hm-content title="">
    <div class="table-panel flex flex-end">
      <div>
        <el-select
          size="small"
          v-model="searchCondition.reportType"
          class="mr10"
          filterable
          clearable
          @change="reportTypeChange"
        >
          <el-option
            v-for="(item, i) in dataReportTypeList"
            :key="i"
            :label="item.itemText"
            :value="item.itemValue"
          ></el-option>
        </el-select>
        <el-input
          clearable
          v-model.trim="searchCondition.keyWords"
          placeholder="请输入编码/名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div>
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="reportCode"
          label="编码"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="reportName"
          label="名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="remark"
          label="说明"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sysCategoryFullName"
          label="分类"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="reportType"
          label="应用类型"
        >
        <template slot-scope="scope">
          <div v-for="(v,i) in dataReportTypeList" :key="i">
            <div v-if="v.itemValue === scope.row.reportType">{{v.itemText}}</div>
          </div>
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="状态"
        >
          <template slot-scope="scope">
            {{ scope.row.enabledState === "yes" ? "开启" : "关闭" }}
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <!-- <el-button size="small" type="text" @click="details(scope.row)"
              >分析</el-button
            > -->
            <el-button
              v-if="isShowBtn('authBtn:false')"
              size="small"
              type="text"
              @click="authorization(scope.row)"
              >授权</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          :page-size="pageSize"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-drawer
      custom-class="hm-drawer"
      :wrapperClosable="false"
      title="报表职员权限配置"
      :visible="authorizeDialogVisible"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="drawer-content">
        <el-input
          style="width:230px"
          size="small"
          class="mr10"
          clearable
          placeholder="输入关键字进行搜索"
          v-model="filterText"
        >
        </el-input>
        <!-- <el-button
          type="primary"
          size="small"
          @click="searchStore"
          :disabled="filterText === ''"
          >查询</el-button
        > -->
        <div class="caption">所拥有的权限：</div>
        <el-tree
          :data="allEmployeeList"
          empty-text="暂无权限"
          :props="props"
          :check-strictly="checkStrictly"
          node-key="employeeId"
          default-expand-all
          ref="tree"
          show-checkbox
          :filter-node-method="filterNode"
        ></el-tree>
      </div>
      <div class="drawer-footer flex flex-between item-center">
        <div>
          <el-dropdown
            @visible-change="visibleChange"
            trigger="click"
            @command="selectItem"
          >
            <span class="el-dropdown-link flex item-center">
              树操作
              <i class="el-icon-arrow-up el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                command="checkAll"
                :disabled="filterText.length > 0"
                >全部勾选</el-dropdown-item
              >
              <el-dropdown-item
                command="cancleCheckAll"
                :disabled="filterText.length > 0"
                >取消全选</el-dropdown-item
              >
              <el-dropdown-item command="openAll">展开所有</el-dropdown-item>
              <el-dropdown-item command="cancleOpenAll"
                >合并所有</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div>
          <el-button type="primary" size="small" @click="savePermission"
            >保存</el-button
          >
          <el-button size="small" @click="authorizeDialogVisible = false"
            >返回</el-button
          >
        </div>
      </div>
    </el-drawer>
    <el-dialog
      :close-on-click-modal="false"
      title="角色权限配置"
      width="1000px"
      :visible.sync="authDialogVisible"
    >
      <div class="mb10 flex flex-between">
        <el-button type="primary" size="small" @click="addAuth"
          >新增授权</el-button
        >
        <!-- <div>
          <el-input
            clearable
            style="width:250px"
            v-model.trim="storeName"
            placeholder="请输入商户名称"
            size="small"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="searchAuth"
            >查询</el-button
          >
        </div> -->
      </div>
      <div>
        <el-table
          :data="hasAuthList"
          style="width: 100%"
          stripe
          border
          size="small"
          :min-height="400"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPageAuth - 1) * pageSizeAuth + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            label="职员名称"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="hu"
            label="职员账号"
          ></el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="workNum"
            label="工号"
          ></el-table-column>

          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="cancelAuth(scope.row)"
                >取消授权</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalAuth"
            @current-change="pagingAuth"
            :page-size="pageSizeAuth"
            @size-change="handleSizeChangeAuth"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPageAuth"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <hm-filter-employee
      selectType="multiple"
      v-if="dialogVisibleEmp"
      @setMultipleEmpInfo="setMultipleEmpInfo"
      :visible="dialogVisibleEmp"
      @close="dialogVisibleEmp = false"
    ></hm-filter-employee>
  </hm-content>
</template>

<script>
import HmFilterEmployee from "@/components/HmFilterEmployee";
export default {
  components: { HmFilterEmployee },
  data() {
    return {
      dialogVisibleEmp: false,
      authDialogVisible: false,
      hasAuthList: [],
      currentPageAuth: 1,
      pageSizeAuth: 10,
      totalAuth: 0,
      filterText: "",
      props: {
        label: "realname",
        children: "children"
      },
      authorizeDialogVisible: false,
      checkStrictly: true,
      searchCondition: {},
      list: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      row: {},
      allEmployeeList: [],
      dataReportTypeList: [],
    };
  },
  computed: {},
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {},
  mounted() {
    this.queryList();
    this.queryAllEmployee();
    this.queryReportDataReportType();
  },
  methods: {
    async cancelAuth(row) {
      const result = await this.$confirm("是否确定取消授权?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });

      if (result === "confirm") {
        const { code } = await this.$store.dispatch("cancelEmpAuth", {
          employeeId: row.employeeId,
          configId: row.configId
        });
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryHasAuth();
        }
      }
    },
    setMultipleEmpInfo(info) {
      let employeeIdList = info.map(o => o.employeeId);
      this.$store
        .dispatch("cancelSaveAuth", {
          employeeIdList,
          configId: this.row.id
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.dialogVisibleEmp = false;
            this.queryHasAuth();
          }
        });
    },
    addAuth() {
      this.dialogVisibleEmp = true;
      // this.authorizeDialogVisible = true;
    },
    handleSizeChangeAuth(size) {
      this.currentPageAuth = 1;
      this.pageSizeAuth = size;
      this.queryHasAuth();
    },
    pagingAuth(page) {
      this.currentPageAuth = page;
      this.queryHasAuth();
    },
    searchAuth() {
      this.currentPageAuth = 1;
      this.queryHasAuth();
    },
    async queryHasAuth() {
      const { result } = await this.$store.dispatch("queryAllAuthEmp", {
        configId: this.row.id,
        pageNo: this.currentPageAuth,
        pageSize: this.pageSizeAuth
      });
      const { records, total } = result;
      this.hasAuthList = records;
      this.totalAuth = total;
      // let ids = result.records.map(v => v.employeeId);
      // setTimeout(() => {
      //   this.$refs.tree.setCheckedKeys(ids);
      // }, 100);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.realname.indexOf(value) !== -1;
    },
    async queryAllEmployee() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        loginType: "store",
        workingState: "yes"
      };
      const { result } = await this.$store.dispatch(
        "queryAllEmployeeList",
        params
      );
      this.allEmployeeList = result.records;
    },
    async savePermission() {
      if (this.$refs.tree.getCheckedNodes().length) {
        const employeeIdList = this.$refs.tree
          .getCheckedNodes()
          .map(v => v.employeeId);
        const { code } = await this.$store.dispatch("saveAuthEmp", {
          configId: this.row.id,
          employeeIdList
        });
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.allEmployeeList = [];
          this.filterText = "";
          this.authorizeDialogVisible = false;
          this.queryAllEmployee();
          this.queryList();
        }
      } else {
        this.$message({
          message: "请选择职员!",
          type: "warning"
        });
      }
    },
    visibleChange(visible) {
      this.checkStrictly = !visible;
    },
    selectItem(e) {
      let expand = false;

      switch (e) {
        case "checkAll":
          this.$refs.tree.setCheckedNodes(this.allEmployeeList);
          break;
        case "cancleCheckAll":
          this.$refs.tree.setCheckedNodes([]);
          break;
        case "openAll":
          expand = true;
          break;
        case "cancleOpenAll":
          expand = false;
          break;
        default:
          break;
      }
      for (let i = 0; i < this.$refs.tree.store._getAllNodes().length; i++) {
        this.$refs.tree.store._getAllNodes()[i].expanded = expand;
      }
    },
    handleClose() {
      this.authorizeDialogVisible = false;
    },
    authorization(row) {
      this.row = row;
      this.queryHasAuth();
      this.authDialogVisible = true;
      // this.authorizeDialogVisible = true;
    },
    details(row) {
      this.$router.push({
        name: "CustomReportAnalyze",
        query: {
          id: row.id
        }
      });
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryAuthPageList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    async queryReportDataReportType() {
      const { result } = await this.$store.dispatch(
        "queryReportDataReportType"
      );
      this.dataReportTypeList = result;
    },
    reportTypeChange(val) {
      console.log("val: ", val);
    },
  }
};
</script>
<style lang="scss" scoped></style>
